import React from 'react';
import { Helmet, HelmetProvider } from "react-helmet-async";

function Impressum() {

    return <>
        <HelmetProvider>
            <Helmet>
                <title>Impressum - Aronium</title>
                <meta name="description" content="Aronium company details" />
            </Helmet>
        </HelmetProvider>

        <section className="py-8">
            <div className="max-w-screen-xl mx-auto text-center">
                <h1 className="text-4xl mb-4">Impressum</h1>
                <p>Legal information and company details</p>
            </div>
        </section>

        <section className="py-20 max-w-screen-xl mx-auto p-4">
            <div className="md:my-auto prose">
                <h2 className='mb-2'>Aronium GmbH</h2>
                <p>Akazienstraße 3a <br />
                    10823 Berlin </p>

                <p>Geschäftsführung: Aleksandra Kukanjac</p>
                <p>Email: <a href='mailto:office@aronium.com'>office@aronium.com</a></p>
                <p>Handelsregister: HRB 262489 B <br />
                    Ust-ID: DE367997304</p>
            </div>
        </section>
    </>
}

export default Impressum;